// Saudi license plate renderer — plate stored as "ABC 1234" (3 Latin letters + 4 digits)
const AR_LETTERS = { A: "ا", B: "ب", J: "ح", D: "د", R: "ر", S: "س", X: "ص", T: "ط", E: "ع", G: "ق", K: "ك", L: "ل", Z: "م", N: "ن", H: "هـ", U: "و", V: "ى" };
const AR_DIGITS = { 0: "٠", 1: "١", 2: "٢", 3: "٣", 4: "٤", 5: "٥", 6: "٦", 7: "٧", 8: "٨", 9: "٩" };

export const PLATE_ALLOWED_LETTERS = Object.keys(AR_LETTERS).join("");

export const SaudiPlate = ({ plate, className = "" }) => {
  const m = /^([A-Z]{1,3})\s*(\d{1,4})$/.exec((plate || "").trim());
  if (!m) return <span className="font-mono text-sm" dir="ltr">{plate}</span>;
  const [, letters, digits] = m;
  const arLetters = letters.split("").map((c) => AR_LETTERS[c] || c).join(" ");
  const arDigits = digits.split("").map((c) => AR_DIGITS[c] || c).join("");
  return (
    <div dir="ltr" className={`inline-flex items-stretch rounded-md border-2 border-slate-800 bg-slate-50 overflow-hidden select-none ${className}`} data-testid="saudi-plate">
      <div className="grid grid-rows-2 divide-x divide-y divide-slate-800 text-center leading-none" style={{ gridTemplateColumns: "4.6em 4.6em" }}>
        <div className="px-1 py-1 font-bold text-slate-800 overflow-hidden whitespace-nowrap" style={{ fontSize: "0.9em" }}>{arDigits}</div>
        <div className="px-1 py-1 font-bold text-slate-800 overflow-hidden whitespace-nowrap" dir="rtl" style={{ fontSize: "0.9em" }}>{arLetters}</div>
        <div className="px-1 py-1 font-bold text-slate-800 tracking-widest font-mono overflow-hidden whitespace-nowrap" style={{ fontSize: "0.85em" }}>{digits}</div>
        <div className="px-1 py-1 font-bold text-slate-800 tracking-widest font-mono overflow-hidden whitespace-nowrap" style={{ fontSize: "0.85em" }}>{letters}</div>
      </div>
      <div className="flex flex-col items-center justify-center bg-white border-l-2 border-slate-800 py-0.5" style={{ width: "1.9em" }}>
        <span className="font-bold text-slate-800" style={{ fontSize: "0.5em" }}>السعودية</span>
        <span className="font-bold text-slate-800 tracking-tighter" style={{ fontSize: "0.55em" }}>KSA</span>
        <span className="rounded-full bg-slate-800 inline-block" style={{ width: "0.35em", height: "0.35em" }} />
      </div>
    </div>
  );
};
